import { ClientTankPlanningView } from "@/components/tank-planning/ClientTankPlanningView";

/** Customer portal: read-only Tank Schedule. See reqs/34-client-tank-planning.md. */
export default function ClientTankSchedule() {
  return (
    <div className="h-full flex flex-col">
      <ClientTankPlanningView />
    </div>
  );
}
